// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","385":"AgriculturalLand","395":"Partypolicy","516":"MapOverview","721":"PopulationEmployment","777":"ecology","904":"PeopleLivelihood"}[chunkId] + "." + {"177":"51c6deb6","385":"8c46e25f","395":"b8f3b4a1","516":"5ad3c790","721":"1ae767b7","777":"ae30391a","904":"0cdf2da1"}[chunkId] + ".css";
};